import React from 'react';
import PropTypes, { object } from 'prop-types';

import { Heading } from 'components/common/Elements/Elements';
import { DonutNew } from 'components/common/charts/charts';
import { LegendStatus } from 'components/common/charts/parts/parts';

import classes from './HealthStatus.module.scss';

const HealthStatus = ({ data, chartColor }) => {
  return (
    <section className={classes.box}>
      <Heading>Health Status</Heading>
      <div className={classes.content}>
        <DonutNew data={data} chartColor={chartColor} />
        <LegendStatus legendData={data} chartColor={chartColor} />
      </div>
    </section>
  );
};

HealthStatus.propTypes = {
  data: PropTypes.arrayOf(object),
  chartColor: PropTypes.object
};

export default HealthStatus;
